import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function UploadSection({ authHeader }) {
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const fileRef = useRef();

  const upload = async (file) => {
    if (!file) return;
    setUploading(true); setResult(null);
    const fd = new FormData(); fd.append('file', file);
    try {
      const res = await axios.post(`${API}/api/accidentes/upload`, fd, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
      setResult(res.data); toast.success(`${res.data.inserted} accidentes insertados`);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Error al subir'); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ''; }
  };

  return (
    <div className="space-y-4 max-w-2xl" data-testid="accidentes-upload">
      <div className="rounded-xl p-6 text-center" style={{ background: 'var(--vz-bg-elevated)', border: '2px dashed var(--vz-border-subtle)' }}>
        <Upload size={32} className="mx-auto mb-3" style={{ color: 'var(--vz-text-muted)' }} />
        <p className="text-sm font-semibold text-white mb-1">Subir CSV de partes Delt@</p>
        <p className="text-[11px] mb-4" style={{ color: 'var(--vz-text-muted)' }}>El sistema detecta duplicados por trabajador-fecha-cliente y mapea automáticamente al centro Valoriza.</p>
        <input ref={fileRef} type="file" accept=".csv" onChange={e => upload(e.target.files[0])} className="hidden" data-testid="acc-upload-input" />
        <Button size="sm" className="text-xs gap-1.5" disabled={uploading} onClick={() => fileRef.current?.click()} data-testid="acc-upload-btn">
          <Upload size={11} /> {uploading ? 'Subiendo y procesando...' : 'Seleccionar CSV'}
        </Button>
      </div>
      {result && (
        <div className="rounded-xl p-4 space-y-2" style={{ background: 'rgba(76,175,80,0.08)', border: '1px solid rgba(76,175,80,0.3)' }}>
          <p className="text-xs font-semibold" style={{ color: '#4CAF50' }}>Subida completada</p>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-[11px]">
            <div><span className="font-semibold">{result.inserted}</span> insertados</div>
            <div><span className="font-semibold">{result.duplicates}</span> duplicados</div>
            <div><span className="font-semibold">{result.invalid}</span> inválidos</div>
            <div style={{ color: '#4A9EFF' }}><span className="font-semibold">{result.mapped_to_sede}</span> mapeados a sede</div>
            <div style={{ color: '#F97316' }}><span className="font-semibold">{result.sin_centro}</span> sin centro</div>
          </div>
        </div>
      )}
    </div>
  );
}
